<style scoped lang="scss"></style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/in/order/detail/page" getKey="rows" :columns="columns" @afterGet="afterGet">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="putInAll" type="primary" :loading="putInAllLoading" :disabled="availableList.length === 0">{{ $t('quanburuku') }}</el-button>
      </template>

      <template #mingxizhuangtai="scope">
        <span v-if="scope.row.status === 0">{{ $t('weiruku') }}</span>
        <span v-if="scope.row.status === 1">{{ $t('bufenruku') }}</span>
        <span v-if="scope.row.status === 2">{{ $t('quanburuku') }}</span>
      </template>
      <template #wuliaobianmamingcheng="scope">
        <span v-if="scope.row.material">{{ scope.row.material.code }} / {{ scope.row.material.name }}</span>
      </template>
      <template #bencishishou="scope">
        <div style="display: flex;justify-content: center;align-items: center;">
          <div v-if="scope.row.dueQuantity === 0">0</div>
          <el-input-number v-else size="mini" v-model="scope.row.newReceiveQuantity" :min="0" :max="scope.row.dueQuantity" :precision="5"></el-input-number>
        </div>
      </template>
      <template #cangkukuqukuwei="scope">
        <div style="display: flex;justify-content: center;align-items: center;" v-if="scope.row.dueQuantity > 0">
          <yi_data_select key="1" :showAllLevels="true" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" type="warehouse" :idsPathParent.sync="scope.row.idsPathParent" :ids.sync="scope.row.warehouseId"> </yi_data_select>
        </div>
      </template>
      <template #caozuochukuzhuangtai="scope">
        <div v-if="runStorageStatusMap.get(scope.row.id)">
          <el-tag :type="runStorageStatusMap.get(scope.row.id) === 'success' ? 'success' : 'danger'">{{ $t(runStorageStatusMap.get(scope.row.id))  }}</el-tag>
        </div>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.dueQuantity > 0">
            <el-button type="text" @click="putIn(scope.row)" :loading="scope.row.putInLoading">{{ $t('ruku') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';

export default {
  name: 'web_wms_receipt_without_order_storage',
  components: {},
  props: {
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      putInAllLoading: false,
      runStorageStatusMap: new Map(),
      columns: [
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'slot',
          width: 100
        },
        {
          label: 'wuliaobianmamingcheng',
          type: 'slot'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE',
          width: 100
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo',
          width: 150
        },
        {
          label: 'rukushuliang',
          prop: 'quantity',
          width: 100
        },
        {
          label: 'shishoushuliang',
          prop: 'actualQuantity',
          width: 100
        },
        {
          label: 'weishoushuliang',
          prop: 'dueQuantity',
          width: 100
        },
        {
          label: 'bencishishou',
          type: 'slot',
          isStar: true
        },
        {
          label: 'cangkukuqukuwei',
          type: 'slot',
          isStar: true
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          show: this.colorNoEnable
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuochukuzhuangtai',
          prop: 'runStorageStatus',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    availableList() {
      if (this.yt.list) {
        let arr = [];
        const list = this.yt.list || [];
        for (let i = 0; i < list.length; i++) {
          if (list[i].dueQuantity === 0) {
            continue;
          }
          arr.push(list[i]);
        }
        return arr;
      } else {
        return [];
      }
    }
  },
  created() {
    setTimeout(() => {
      if (this.row) {
        this.yt.conditions = {
          inOrderId: this.row.id
        };
      }
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 全部入库
    putInAll() {
      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '无单入库-全部入库' } });
      this.putInAllLoading = true;
      let list = this.yt.list || [];
      let completedCount = 0;
      const totalItems = list.filter(row => row.dueQuantity !== 0).length;
      for (let i = 0; i < list.length; i++) {
        const row = list[i];
        if (list[i].dueQuantity === 0) {
          continue;
        }

        // putIn 方法内部会调用一个回调函数来通知完成
        this.$set(row, 'putInCallback', () => {
          completedCount++;
          if (completedCount === totalItems) {
            this.putInAllLoading = false;
            this.$message.success(this.$t('rukuwancheng'));
            this.yt.get();
          }
        });
        this.putIn(row, false);
      }
    },
    // 单个入库
    putIn(row, refresh = true) {
      if (refresh) {
        Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '无单入库-单个入库' } });
      }
      const data = {
        id: row.id,
        warehouseId: (row.idsPathParent && row.idsPathParent[0]) || null,
        warehouseAreaId: (row.idsPathParent && row.idsPathParent[1]) || null,
        warehouseLocationId: (row.idsPathParent && row.idsPathParent[2]) || null,
        materialId: row.material.id,
        materialBatchNo: row.materialBatchNo,
        quantity: row.quantity,
        dueQuantity: row.dueQuantity,
        newReceiveQuantity: row.newReceiveQuantity,
        unit: row.unit,
        remark: row.remark
      };
      
      this.$set(row, 'putInLoading', true);
      this.http
        .post('/web/in/order/detail/putIn', data)
        .then(res => {
          this.runStorageStatusMap.set(row.id, res.msg);
          if (refresh) {
            this.$message.success(this.$t(res.msg));
            this.yt.get();
          }
        })
        .catch(err => {
          this.runStorageStatusMap.set(row.id, err);
          if (refresh) {
            this.$message.error(this.$t(err));
          }
        })
        .finally(() => {
          this.$set(row, 'putInLoading', false);
          if (row.putInCallback) {
            row.putInCallback();
          }
        });
    },
    // 表格数据获取成功后
    afterGet() {
      let list = this.yt.list || [];
      // 初始化本次实收值为未收数量、默认仓库库区库位
      for (let i = 0; i < list.length; i++) {
        if (list[i].dueQuantity === 0) {
          continue;
        }
        this.$set(list[i], 'newReceiveQuantity', list[i].dueQuantity || 0);
        this.$set(list[i], 'idsPathParent', []);
        this.setLatestWarehouse(list[i]);
      }
    },
    // 设置最新的默认仓库
    setLatestWarehouse(row) {
      this.http.get('/web/material/warehouse/getLatestOne', { params: { materialId: row.material.id } }).then(res => {
        const data = res.data;
        if (!data) {
          return;
        }
        if (data.warehouseLocationId) {
          this.$set(row, 'warehouseId', parseInt('3' + data.warehouseLocationId));
          return;
        }
        if (data.warehouseAreaId) {
          this.$set(row, 'warehouseId', parseInt('2' + data.warehouseAreaId));
          return;
        }
        if (data.warehouseId) {
          this.$set(row, 'warehouseId', parseInt('1' + data.warehouseId));
          return;
        }
      });
    }
  }
};
</script>
